export default "__VITE_ASSET__169d46ea__"